import React, { useContext, useEffect, useState } from 'react';
import CategoryItem from './CategoryItem';
import NewCategoryModal from './NewCategoryModal';
import { CategoriesContext } from '../../../contexts/CategoriesContext';
import Category from '../../../models/Category/Category';
import Paginator from '../../../components/Paginator';
import Card from '../../../components/Card';
import Table from '../../../components/Table/Table';
import DeleteModal from '../../../components/Modals/DeleteModal/DeleteModal';

const Index = () => {
  const {
    categories, handleSave, handleDelete, requestCategoryList, currentPage, total, links,
  } = useContext(CategoriesContext);
  // '' -> new category
  // 'value' -> edit category
  // null -> close modal
  const [editCategory, setEditCategory] = useState<Category | '' | null>(null);
  const [deleteCategoryId, setDeleteCategoryId] = useState('');
  const [deleteCategoryTitle, setDeleteCategoryTitle] = useState('');

  const handleDeleteModalOpen = (id: string, title: string) => {
    setDeleteCategoryId(id);
    setDeleteCategoryTitle(`「${title}」を削除してもよろしいですか？`);
  };

  const changePage = (page: number) => {
    requestCategoryList(page);
  };

  useEffect(() => {
    requestCategoryList();
  }, [requestCategoryList]);

  return (
    <div className="main">
      <main className="content p-3">
        <Card title="カテゴリ管理" subTitle="カテゴリ一覧" onClickCreate={() => setEditCategory('')}>
          <div className="row row-cols-auto g-1">
              {/* <Search onSearch={(text: any) => setSearchText(text)} /> */}
              <Paginator currentPage={currentPage} changePage={changePage} links={links} />
          </div>
          <Table>
            <thead>
            <tr>
                <th style={{ width: '5%' }}>表示順</th>
                <th style={{ width: '20%' }}>カテゴリ名</th>
                <th>カテゴリ説明</th>
                <th className="text-center" style={{ width: '120px' }}>操作</th>
            </tr>
            </thead>
            <tbody>
            {categories.map((category) => (
              <CategoryItem
                key={category.id}
                no={Number(category.order)}
                title={category.title}
                description={category.description}
                order={category.order}
                handleEdit={() => {
                  setEditCategory(category);
                }}
                handleDelete={() => {
                  handleDeleteModalOpen(category.id, category.title);
                }}
              />
            ))}
            </tbody>
          </Table>
            <div className="row row-cols-auto g-1 align-items-center">
              <div className="col ">
                <div className="page-item-count text-sm">
                  全
                  {' '}
                  <span>{total}</span>
                  {' '}
                  件
                </div>
              </div>
              <Paginator currentPage={currentPage} changePage={changePage} links={links} />
            </div>
        </Card>
      </main>

    <NewCategoryModal
      open={editCategory != null}
      handleClose={() => setEditCategory(null)}
      handleSave={async (category) => {
        await handleSave(category);
        requestCategoryList(currentPage);
        setEditCategory(null);
      }}
      editCategory={editCategory}
    />
    <DeleteModal
      open={deleteCategoryId !== ''}
      title="カテゴリ削除"
      desc={deleteCategoryTitle}
      handleClose={() => setDeleteCategoryId('')}
      handleSave={async () => {
        await handleDelete(deleteCategoryId);
        setDeleteCategoryId('');
        requestCategoryList(currentPage);
      }}
    />
    <footer className="footer d-none">
      <div className="container-fluid">
        <div className="row text-muted">
          <div className="col-6 text-start">
            &copy; 2023 BUILD-SELF
          </div>
          <div className="col-6 text-end">
            <div className="d-none d-sm-block">ver 1.0.0</div>
          </div>
        </div>
      </div>
    </footer>
    <a className="scroll-to-top rounded"><i className="fa-solid fa-angle-up" /></a>

    </div>
  );
};

export default Index;
